/** @format */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { LotCountingActions, SuperAdminAction } from "../../Actions";

class ViewOccupancy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_status: "NOT FULL",
      current_occupancy: 0,
      current_free: 0,
      total_stalls: 0,
      show_full_above: 0,
      show_not_full_below: 0,
      update_button: true,
      api_response: false,
      PropertyId: this.props.property_id,
      property: this.props.property,
      LotId: "6fd06774-52b1-4264-b3ce-b4244a73ff8a",
      LotCounterLots: [],
      isDisabled: true,
      ShowCondition: false,
    };
  }

  componentDidMount = async () => {
    // for edit resident details
    // const { PropertyId, ResidentId } = this.state;
    const { PropertyId } = this.state;
    // this.props.select_edit_resident(PropertyId, ResidentId).then(() => {
    await this.props.select_edit_lotcounting(PropertyId);
    const selectedPropertyName = this.state.property?.property_name;
    const selectedDomainName = this.state.property?.domain;
    this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
    console.log("lotcounting_list", this.props.lotcounting_list);
    this.setState(
      { editedLotCounted: this.props.lotcounting_list, isFormValid: true },
      () => {
        this.settingData();
      }
    );
    this.settingData();
  };

  settingData = () => {
    const { editedLotCounted } = this.state;
    if (editedLotCounted) {
      const {
        current_occupancy,
        current_free,
        total_stalls,
        show_full_above,
        show_not_full_below,
      } = editedLotCounted;

      this.setState({
        current_occupancy,
        total_stalls,
        current_free,
        show_full_above,
        show_not_full_below,
        updated_current_occupancy: current_occupancy,
      });
    }
  };

  refresh = () => {
    window.location.reload();
  };

  handleSubmit = async () => {
    const {
      current_occupancy,
      total_stalls,
      show_full_above,
      show_not_full_below,
    } = this.state;
    const lotcounting_list = {
      current_occupancy,
      total_stalls,
      show_full_above: +show_full_above,
      show_not_full_below,
    };
    const Obj = { ...lotcounting_list };
    await this.props.edit_lotcounting(Obj, this.props.property_id);
    if (this.props.api_response) {
      this.setState(
        {
          show_alert: true,
          isDisabled: true,
          api_success_message: this.props.api_success_message,
        },
        () => {
          setTimeout(() => {
            this.setState({ show_alert: false });
          }, 4000);
        }
      );
    } else {
      this.setState({ show_error: true });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  handleChange(e) {
    const {
      current_occupancy,
      total_stalls,
      show_full_above,
      show_not_full_below,
    } = e.target.validity.valid ? e.target.value : this.state;
    this.setState({
      total_stalls,
      show_full_above,
      show_not_full_below,
      current_occupancy,
      update_button: false,
    });
  }

  updateTotalStalls(event) {
    this.setState({
      total_stalls: event.target.value,
    });
  }

  updateShowFullAbove(event) {
    const {
      total_stalls,
      show_full_above,
      show_not_full_below,
      current_occupancy,
    } = this.state;
    if (
      show_full_above > 0 &&
      show_full_above < total_stalls &&
      show_not_full_below > 0 &&
      show_not_full_below <= show_full_above &&
      current_occupancy <= total_stalls
    ) {
      this.setState({
        ShowCondition: false,
        update_button: false,
      });
    } else {
      this.setState({
        update_button: true,
        ShowCondition: true,
      });
    }

    this.setState({
      show_full_above: event.target.value,
    });
  }

  updateShowNotFullAbove(event) {
    const {
      total_stalls,
      show_full_above,
      show_not_full_below,
      current_occupancy,
    } = this.state;
    if (
      show_full_above > 0 &&
      show_full_above < total_stalls &&
      show_not_full_below > 0 &&
      show_not_full_below <= show_full_above &&
      current_occupancy <= total_stalls
    ) {
      this.setState({
        ShowCondition: false,
        update_button: false,
      });
    } else {
      this.setState({
        update_button: true,
        ShowCondition: true,
      });
    }

    this.setState({
      show_not_full_below: event.target.value,
    });
  }

  updateCurrentOccupancy(event) {
    const {
      total_stalls,
      show_full_above,
      show_not_full_below,
      current_occupancy,
    } = this.state;
    if (
      show_full_above > 0 &&
      show_full_above < total_stalls &&
      show_not_full_below > 0 &&
      show_not_full_below <= show_full_above &&
      current_occupancy <= total_stalls
    ) {
      this.setState({
        ShowCondition: false,
        update_button: false,
      });
    } else {
      this.setState({
        update_button: true,
        ShowCondition: true,
      });
    }
    this.setState({
      current_occupancy: event.target.value,
    });
  }

  componentDidUpdate = (prevProps) => {
    if (
      JSON.stringify(this.props.lotcounter_list) !==
      JSON.stringify(prevProps.lotcounter_list)
    ) {
      this.setState({ cameraList: this.props.lotcounter_list });
    }
  };

  handleChangeLot = async ({ target }) => {
    this.setState({ [target.name]: target.value });
    if (target.value !== "ANY") {
      await this.props.get_all_lanes([target.value]);
    } else {
      await this.props.get_all_lots(this.state.PropertyId);
      const current_lot = this.props.lots;
      if (current_lot && current_lot.length) {
        const lot_ids = current_lot.map((el) => {
          return el.id;
        });
        await this.props.get_all_lanes(lot_ids);
      }
      const current_lanes = this.props.currentLane;
      this.setState({
        lprReportLanes: current_lanes,
        lane_id: "ANY",
      });
    }
  };

  handleEditButton(e) {
    e.preventDefault();
    this.setState({
      update_button: false,
      isDisabled: false,
    });
  }

  render() {
    const {
      current_status,
      current_occupancy,
      current_free,
      total_stalls,
      show_full_above,
      show_not_full_below,
      update_button,
      isDisabled,
      updated_current_occupancy,
    } = this.state;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="contact-container mb-0">
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  <Card.Title as="h4">Lot Count</Card.Title>
                  <p className="card-category"></p>
                </Card.Header>
                <Card.Body>
                  <Row className="d-flex flex-wrap">
                    <Col className="min-w-200px">
                      <Form.Label>CURRENT STATUS</Form.Label>
                      <p>{current_status || "-"}</p>
                    </Col>
                    <Col className="min-w-200px">
                      <Form.Label>CURRENT OCCUPANCY</Form.Label>
                      <p>{updated_current_occupancy || "-"}</p>
                    </Col>
                    <Col className="min-w-200px">
                      <Form.Group>
                        <Form.Label>CURRENT FREE</Form.Label>
                        <p>{current_free || "-"}</p>
                      </Form.Group>
                    </Col>
                    <Col className="min-w-200px">
                      <Form.Group>
                        <Button
                          className="btn-fill mt-4 btn-sm"
                          type="button"
                          variant="info"
                          onClick={this.refresh}
                        >
                          Refresh
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="d-flex flex-wrap">
                    <Col className="min-w-200px">
                      <Form.Label>TOTAL STALLS</Form.Label>
                      <Form.Control
                        type="number"
                        id="total_stalls"
                        value={total_stalls}
                        onChange={this.updateTotalStalls.bind(this)}
                        pattern="[0-9]*"
                        disabled={isDisabled}
                        min={0}
                        className="form-control form-control-sm"
                      />
                    </Col>
                    <Col className="min-w-200px">
                      <Form.Label>SHOW FULL ABOVE</Form.Label>
                      <Form.Control
                        type="number"
                        value={show_full_above}
                        onChange={this.updateShowFullAbove.bind(this)}
                        id="show_full_above"
                        className="form-control form-control-sm"
                        pattern="[0-9]*"
                        disabled={isDisabled}
                        min={0}
                      />
                    </Col>
                    <Col className="min-w-200px">
                      <Form.Label>SHOW NOT FULL BELOW</Form.Label>
                      <Form.Control
                        type="number"
                        id="show_not_full_below"
                        value={show_not_full_below}
                        onChange={this.updateShowNotFullAbove.bind(this)}
                        className="form-control form-control-sm"
                        pattern="[0-9]*"
                        disabled={isDisabled}
                        min={0}
                        placeholder=""
                      />
                    </Col>
                    <Col className="min-w-200px">
                      <Form.Label>CURRENT OCCUPANCY</Form.Label>
                      <Form.Control
                        type="number"
                        id="current_occupancy"
                        value={current_occupancy}
                        onChange={this.updateCurrentOccupancy.bind(this)}
                        className="form-control form-control-sm"
                        placeholder=""
                        pattern="[0-9]*"
                        disabled={isDisabled}
                        min={0}
                      />
                    </Col>
                    <Col className="min-w-200px">
                      <Button
                        className="btn-fill mt-4 btn-sm"
                        type="button"
                        variant="info"
                        onClick={this.handleEditButton.bind(this)}
                      >
                        Edit
                      </Button>
                      <Button
                        className="btn-fill ml-2 mt-4 btn-sm"
                        type="button"
                        variant="info"
                        disabled={update_button}
                        onClick={this.handleSubmit.bind(this)}
                      >
                        Update
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({
  LotCountingDetails,
  APIResponseDetails,
  UserProfileDetails,
  Logindetails,
}) => {
  const { lotcounting_list, LotCounterLots } = LotCountingDetails;
  const { property } = UserProfileDetails;
  const { api_response, api_success_message, api_error_message } =
    APIResponseDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    lotcounting_list,
    api_response,
    api_success_message,
    api_error_message,
    property,
    main_body,
    LotCounterLots,
  };
};

const mapStateToDispatch = {
  select_edit_lotcounting: LotCountingActions.select_edit_lotcounting,
  edit_lotcounting: LotCountingActions.edit_lotcounting,
  setDomainHeader: SuperAdminAction.setDomainHeader,
  get_all_lots: SuperAdminAction.get_all_lots,
};

export default connect(mapStateToProps, mapStateToDispatch)(ViewOccupancy);
